<template>
  <div>
    <v-select
      v-model="options"
      :items="optionList"
      :rules="rules"
      :multiple="false"
      :label="label"
      :disabled="disabled"
      clearable
      outlined
      dense
      @change="change"
    ></v-select>
  </div>
</template>
<script>
import { default as StoreApi } from '@/api/pd/common/StoreApi.js'

export default {
  name: 'ShopSelect',
  data() {
    return {
      list: [],
      loading: false,
    }
  },
  props: {
    value: {
      type: [Number,String],
    },
    label:{
      type: String
    },
    rules: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    shopIdList: {
      type: Array,
      default: null,
    },
    selectFirst:{
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  computed: {
    options: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
    optionList() {
      let optionList = this.list;
      if (this.shopIdList) {
        optionList = this.list.filter(item => this.shopIdList.indexOf(item.value) > -1);
      }
      if (this.isSearch) {
        if (optionList && optionList.length == 1) {
          this.options = optionList[0].value;
        }
      }else if(this.selectFirst && optionList && optionList.length > 0){
        this.options = optionList[0].value;
      }
      return optionList;
    }
  },
  created() {
    StoreApi.queryStoreList().then(
      (response) => {
        if(response.data.code==200){
          response.data.data.shopPriviledges.concat(response.data.data.shopPriviledges)
          this.list = response.data.data.shopPriviledges.map((shop) => {
            return {
              text: shop.shopName,
              value: shop.shopId + '',
            }
          })

          // console.log('this.fruits',this.fruits)
        }
      }
    )
  },
  methods:{
    change(value){
      this.$emit('change',value)
    }
  }
}
</script>
